// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2gyC4","vLegacy":"SelectSecondary_vLegacy__3uOll","error":"SelectSecondary_error__Xq4nU","disabled":"SelectSecondary_disabled__3MJ3G"};